<template>
  <div>
    <div class="es-op-box">
      <el-input placeholder="请输入挂起原因"
                v-model="queryObj.keyWord"
                size="small"
                class="query"
                style="float: left"
                clearable
                @change="()=>{this.queryObj.pageNum = 1;init()}">
        <i slot="suffix"
           class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="primary"
                 icon="el-icon-font el-icon-web__tianjia"
                 size="mini"
                 style="margin-right:6px"
                 @click="add_init">新增</el-button>

      <es-delete @del="del()"
                 type="button"></es-delete>

    </div>
    <el-table :data="pageData.list"
              ref="hangReasonTable"
              border
              stripe
              size="mini"
              height="calc(100vh - 180px)"
              style="cursor: pointer;"
              @current-change="showDetail"
              v-loading="loading">
      <el-table-column type="selection"
                       width="40"
                       align="center">
      </el-table-column>
      <el-table-column type="index"
                       label="序号"
                       width="50"
                       align="center">
      </el-table-column>
      <el-table-column prop="name"
                       label="挂起原因">
      </el-table-column>
      <el-table-column label="操作"
                       width="80"
                       align="center">
        <template slot-scope="scope">
          <el-link :underline="false"
                   title="编辑"
                   @click="edit_init(scope.row)"
                   type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete @del="del(scope.row.id)"
                     :key="scope.row.id"
                     type="icon"></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination :data="pageData"
                     @change="(cpage)=>{this.queryObj.pageNum=cpage;this.loadHangReasonList()}">
      </es-pagination>
    </div>

    <!--编辑挂起原因-->
    <el-dialog :visible.sync="editVisible"
               @closed="()=>this.$refs['hangReasonForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑挂起原因
      </span>
      <el-form :model="hangReasonInfo"
               :rules="rules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="hangReasonForm">
        <el-form-item prop="name"
                      label="挂起原因">
          <el-input v-model="hangReasonInfo.name"
                    placeholder="请输入挂起原因"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submit()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'fauhangreason',
  props: ["funcs"],
  data () {
    return {
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      editVisible: false,
      hangReasonInfo: {},//挂起原因信息
      rules: {//验证条件
        name: [
          { required: true, message: '请输入挂起原因', trigger: 'blur' },
          { max: 50, message: '不能超过50个字符', trigger: 'blur' }
        ]
      },
      loading: false,
      saving: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadHangReasonList()
    },
    //从后台查询挂起原因
    loadHangReasonList () {
      this.loading = true
      this.$ajax.get('/buss/fauhangreason/list', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //初始化添加挂起原因
    add_init () {
      this.editVisible = true
      this.hangReasonInfo = {}
    },
    //初始化编辑挂起原因
    edit_init (row) {
      this.editVisible = true
      this.hangReasonInfo = JSON.parse(JSON.stringify(row))
    },
    //保存挂起原因
    submit () {
      this.$refs["hangReasonForm"].validate(valid => {
        if (valid) {
          let url = "/buss/fauhangreason/add";
          if (this.hangReasonInfo.id != null) {
            url = "/buss/fauhangreason/edit";
          }
          this.saving = true
          this.$ajax.post(url, this.hangReasonInfo).then(msg => {
            this.saving = false
            this.loadHangReasonList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除挂起原因
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["hangReasonTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/buss/fauhangreason/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadHangReasonList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },

  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
